<template>
  <div class="home">
    <div class="bg bg1"></div>
    <div class="top">
      <div class="box">

        <div class="headportrait">
          <img v-if="account.photo" :src="account.photo" alt="">
          <img v-else src="./assets/img/p.png" alt="">
        </div>

        <div class="information">
          <p class="fz30 c_333 pt16">{{account.nickname}}</p>
          <!-- {{account.huiyuan_expire_at}} -- 
          {{account.huiyuan_time}} -->
          <div v-if="account.huiyuan_expire_at" class="fz24 c_666 pt6">会员有效期至{{account.huiyuan_expire_at_sub}}</div>
          <div class="tel">{{account.account}}</div>
        </div>
        
        <!-- 查看印章 -->
        <div v-if="account.honor">
        <router-link 
          v-for="(v,k) in honorInfo" v-bind:key="k" 
          v-if="v.id==account.honor" 
          :to="{ name: 'rentsrecharge' }"  
          :class="['app-seal'+account.honor]" 
           class="badgebox w154 lh57 df aic jcc poa r0 t30 fz24 c_fff">
          <img src="./assets/img/badge.png" alt="" class="w25 mr10">
          {{v.title}}
        </router-link>
        </div>

        <!-- 会员 -->
        <div v-if="account.huiyuan_time>0" class="huiyuan_label poa t26 r20 pl14 pr14 pt4 pb4 df aic jcc fz24 b_vip c_vip bdrd50">
            <img src="./assets/img/vip_1.png" alt="" class="w28 h25 mr4">
            <span class="ml5">年费会员</span>
        </div>
        
        <div v-if="account.deposit>0" @click="showPop" class="badgebox2 w154 lh57 df aic jcc poa r0 t30 b_vip3 fz24 c_fff">
          <img src="./assets/img/vip_ya2.png" alt="" class="w25 h29 mr10">
          <span>押金返还</span>
        </div>


        <div class="money weui-flex">
            <router-link :to="{ name: 'balance' }" class="weui-flex__item">
              <div class="num">¥{{account.all_money}}</div>
              <p>余额</p>
            </router-link>
            <router-link :to="{ name: 'integral' }" class="weui-flex__item">
              <div class="num">{{account.point}}</div>
              <p>积分</p>
            </router-link>
            <router-link :to="{ name: 'mycard'}" class="weui-flex__item">
              <div class="num">{{coupon}}</div>
              <p>券盒</p>
            </router-link>
        </div>
      </div>
    </div>


    <div class="alinklist weui-cells">
        <router-link :to="{ name: 'vip'}" class="ico1 weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>年费会员</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <router-link v-if="!(account.huiyuan_expire_at)" :to="{ name: 'vip',query:{type:2}}" class="ico7 weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>会员特权</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <router-link :to="{ name: 'cardcenter'}" class="ico2 weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>卡券中心</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <div @click="fenxiao" class="ico3 weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>分销中心</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </div>
        <router-link :to="{ name: 'profit'}" class="ico4 weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>我的收益</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        
        <router-link :to="{ name: 'process'}" class="ico5 weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>洗衣流程</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <router-link :to="{ name: 'help'}" class="ico6 weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>帮助中心</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </router-link>
        <!-- <div @click="logout()" class="weui-cell weui-cell_access">
            <div class="weui-cell__bd">
                <p>退出登录</p>
            </div>
            <div class="weui-cell__ft">
            </div>
        </div> -->
    </div>

    <yajintips v-if="popShow" @myevent="myevent"></yajintips>


  <div v-if="popShowVip" class="yajintips">
    <div class="popb">
      <div class="box1 pb40 b_fff">
        <img @click="popShowVip=false" src="@/assets/img/close1.png" alt="" class="w53 h91 poa b_91 l264">
        <div class="fz32 c_333 pt40 tac por ovh">提示</div>
        <!-- <div class="roll"></div> -->
        <div class="pt30 fz28 c_666 pl40 pr40">
          您的衣印年费会员已到期，为保证您的会员权益，请及时续费。
        </div>
        <div class="pt40 pl40 pr40 tac df jcsb fz30">
          <div @click="conformVip" class="w266 lh80 bdrd50 c_fff b_red">立即续费</div>
          <div @click="popShowVip=false" class="btn2 w206 lh78 bdrd50 c_666">确认</div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import weui from 'weui.js'
  import yajintips from '@/components/yajintips'
  export default{
    components:{
      yajintips
    },
    props: {
        islogin:Boolean,
    },
    data(){
      return{
        account:{nickname:"-",account:"-",point:0,honor:0,money:0.00,money_company:0.00},
        honorInfo:[],
        // honorInfo:[{ id: 0, title: '印章租赁'}],
        coupon:0,
        popShow:false,
        popShowVip:false
      }
    },
    created(){
        if(this.islogin == true){
            this.getAccount();
        }
    },
    watch:{
        'islogin'(){
            if(this.islogin == true){
                this.getAccount();
            }
        }
    },
    methods:{
        fenxiao(){
            if(this.account.huiyuan_expire_at){
                if(this.account.huiyuan_time>0){
                    this.$router.push({name: 'share'})
                }else{
                    weui.topTips('您的年费会员已到期，续费后可使用此功能！')
                }
            }else{
                weui.topTips('使用该功能需开通年费会员！')
            }
        },
      showPop(){
        this.popShow = true;
      },
      myevent(e){
        if(e.refresh){
          this.getAccount();
        }
        if(e.close){
          this.popShow = false;
        }
      },
      getAccount(){
        let vm = this;
        vm.ajax("account", "get", '', e => {
          vm.account = e.data;
          let all_money = vm.account.money + vm.account.money_company;
          vm.account.all_money = all_money.toFixed(2)
          if(vm.account.deposit>0) vm.popShow = true;//是否老印章用户
            // // //test
             //     //   vm.account.honor = 3;
            // vm.account.huiyuan_expire_at = ''//未开通会员
            // vm.account.huiyuan_expire_at = '2021-12-06 22:22:22'//会员中
            // vm.account.huiyuan_expire_at = '2020-12-06 22:22:22'//会员过期
             // //test

            vm.account.huiyuan_expire_at_sub = vm.account.huiyuan_expire_at.substr(0,10);

            let timePop = 1,
                huiyuan_time = new Date(vm.account.huiyuan_expire_at.replace(/-/g,'/')).getTime() - new Date().getTime();
            vm.account.huiyuan_time = huiyuan_time;//>0标示有会员
            if(localStorage.getItem('timePop')){
                timePop = 2;
            }
            if(huiyuan_time<0&&timePop==1){////到期后能在首页通知到用户会员到期
                localStorage.setItem('timePop',1)
                vm.popShowVip = true;
            }

          vm.getHonorInfo();
          vm.getAccountCoupon();
        })
      },
        conformVip(){
            this.$router.push({ name: 'vipbuy' });
            this.popShowVip = false;
        },
      getHonorInfo(){
        let vm = this;
        vm.ajax("account/honor", "get", '', e => {
          vm.honorInfo = e.data.list;
          // vm.honorInfo.push({ id: 0, title: '印章租赁'})
        })
      },
      getAccountCoupon(){
        let vm = this;
        vm.ajax("account/coupon", "get", '', e => {
          if(e.data.enable && e.data.enable.length > 0)
          vm.coupon = e.data.enable.length;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/home.vue